import { clampToMaxPeriod } from '~utils/date-picker-helpers';
import {
    analyticsToday,
    campaignRange,
    CampaignWindow,
} from '~containers/analytics/kpis/periods';

export type { CampaignWindow };

/**
 * Whether the `campaign` capsule selects less than the campaign it names.
 *
 * It is the only preset the period cap can shorten, and the page it sits on
 * shows campaign-to-date totals that are not capped, so a shortened capsule has
 * to label what it selects rather than keep claiming the whole campaign.
 */
export const isCampaignShortened = (
    campaign: CampaignWindow | undefined,
    today: string = analyticsToday()
): boolean => {
    if (!campaign) return false;
    const range = campaignRange(campaign, today);
    return clampToMaxPeriod(range).start !== range.start;
};
